export const ADD_TIME_ON_PAGE_TRIGGER = 'ADD_TIME_ON_PAGE_TRIGGER';
export const REMOVE_TIME_ON_PAGE_TRIGGER = 'REMOVE_TIME_ON_PAGE_TRIGGER';